import { render, staticRenderFns } from "./CandidatesInfo.vue?vue&type=template&id=2dd6506c&scoped=true"
import script from "./CandidatesInfo.vue?vue&type=script&lang=js"
export * from "./CandidatesInfo.vue?vue&type=script&lang=js"
import style0 from "./CandidatesInfo.vue?vue&type=style&index=0&id=2dd6506c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2dd6506c",
  null
  
)

export default component.exports